export default __webpack_public_path__ + "static/media/tufts.aba1c889.svg";